<template>
  <div class="main">
    <div class="main_top">
      <div>
        <!-- <el-input
        class="search"
        placeholder="请输入内容"
        v-model="userSearch"
        clearable
        size="small"
        @change="SearchChange"
      >
      </el-input> -->
      </div>
      <div>
        <Button icon="md-add" @click="addEva('新增')">
          新增
        </Button>
        <Button icon="ios-create" @click="addEva('编辑')">
          编辑
        </Button>
        <Button icon="md-trash" @click="deluser">
          删除
        </Button>
      </div>
      <Modal v-model="modal1" title="保存参数" footer-hide :draggable="true">
        <el-form :model="formInline" :rules="ruleInline" ref="formInline" label-width="120px" class="demo-formInline">
          <el-form-item label="学期名称" prop="semname">
            <el-input v-model="formInline.semname"></el-input>
          </el-form-item>
          <el-form-item label="学年" prop="schoolyear">
            <el-date-picker v-model="formInline.schoolyear" type="year" placeholder="选择日期" value-format="yyyy"> </el-date-picker>
          </el-form-item>
          <el-form-item label="开始时间" prop="startdate">
            <el-date-picker v-model="formInline.startdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="enddate">
            <el-date-picker v-model="formInline.enddate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item label="是否为当前学期" prop="iscurrent">
            <el-switch v-model="formInline.iscurrent" active-text="是" inactive-text="否" style="margin-left:40px"> </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSubmit('formInline')">提交</el-button>
          </el-form-item>
        </el-form>
      </Modal>
    </div>
    <div class="main_body">
      <el-table ref="singleTable" :data="newDataList" highlight-current-row stripe tooltip-effect="dark" @current-change="newChange" style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="80"> </el-table-column>
        <el-table-column property="semname" label="学期" show-overflow-tooltip align="center"> </el-table-column>
        <el-table-column property="schoolyear" label="学年" show-overflow-tooltip align="center"> </el-table-column>
        <el-table-column property="startdate" label="开始日期" show-overflow-tooltip align="center"> </el-table-column>
        <el-table-column property="enddate" label="结束日期" show-overflow-tooltip align="center"> </el-table-column>
        <el-table-column prop="iscurrent" label="状态" align="center" width="160px">
          <template slot-scope="scope">
            <el-switch disabled v-model="scope.row.iscurrent" :active-value="1" :inactive-value="0" active-text="当前学期"> </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <!-- 详情 -->
      <el-dialog title="详情信息" :visible.sync="noticeDialog" width="30%" top="10px">
        <div class="notice_box">
          <span class="notice_box_title">公告标题：</span>
          <span>{{ noticeDetailsData.newstitle }}</span>
        </div>
        <div class="notice_box">
          <span class="notice_box_title">公告内容：</span>
          <span class="notice_box_cont">{{ noticeDetailsData.newscontent }}</span>
        </div>
      </el-dialog>
      <div>
        <el-pagination style="text-align:right;margin-top:20px;" :hide-on-single-page="true" :total="total" :page-size="pagesize" :current-page="currentpage" @current-change="handleCurrentChange" layout="prev, pager, next"> </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data() {
    return {
      modal1: false,
      noticeDialog: false,
      diatitle: '',
      userSearch: '',
      newDataList: [],
      total: 1, //分页总条数
      pagesize: 13, //每页显示数
      currentpage: 1, //当前页
      newsItem: {}, //用户选中项
      evaNameList: [], //参数名称列表
      schoolid: '',
      formInline: {
        semname: '',
        startdate: '',
        enddate: '',
        iscurrent: false,
        schoolid: ''
      },
      ruleInline: {
        newstitle: [{ required: true, message: '请输入标题!', trigger: 'blur' }],
        newscontent: [{ required: true, message: '请输入内容!', trigger: 'blur' }]
      },
      noticeDetailsData: {}
    }
  },
  created() {
    this.GetDataList()
    this.GetSchoolTreeList()
  },
  methods: {
    //搜索
    SearchChange(val) {
      console.log(val)
    },
    //用户表格选中项
    newChange(val) {
      this.newsItem = val
      this.formInline = val
      console.log(this.formInline)
    },
    async GetSchoolTreeList() {
      const res = await Api.school.GetSchoolTreeList()
      if (res.success != true) return this.$Message.info(res.msg)
      if (res.rows && res.rows.length > 0) {
        this.schoolid = res.rows[0]['schoolid']
        this.formInline.schoolid = this.schoolid
      }
    },
    //获取学期列表
    async GetDataList() {
      const req = await Api.semester.GetDataList(0, this.currentpage, this.pagesize)
      if (req.success != true) return this.$Message.info(req.msg)
      this.newDataList = req.rows
    },
    handleCurrentChange(val) {
      this.currentpage = val
      this.GetEvaDataList()
    },
    //新增编辑参数
    async addEva(msg) {
      if (msg == '编辑') {
        if (JSON.stringify(this.newsItem) == '{}') return this.$Message.info('请选择要编辑的参数！')
        console.log(this.newsItem, this.formInline.iscurrent)
        if (this.formInline.iscurrent == 1) {
          this.formInline.iscurrent = true
        } else {
          this.formInline.iscurrent = false
        }
      } else {
        this.formInline = {
          semname: '',
          startdate: '',
          enddate: '',
          iscurrent: false,
          schoolid: this.schoolid
        }
      }
      this.modal1 = true
    },
    //查看详情
    handleClick(e) {
      this.noticeDialog = true
      this.noticeDetailsData = e
    },
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          if (this.formInline.iscurrent) {
            this.formInline.iscurrent = 1
          } else {
            this.formInline.iscurrent = 0
          }
          const res = await Api.semester.SaveData(this.formInline)
          if (res.success != true) return this.$Message.info(res.msg)
          this.$Message.success(res.msg)
          this.modal1 = false
          this.GetDataList()
        } else {
        }
      })
    },
    //删除用户
    async deluser() {
      if (JSON.stringify(this.newsItem) == '{}') return this.$Message.info('请选择要删除的学期！')
      this.$confirm('此操作将永久删除该学期, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await Api.semester.DelData([this.newsItem.semid])
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.GetDataList()
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
  .main_top {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 15px 15px 0 15px;
    .search {
      width: 220px;
    }
    .dropdown {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 400;
      text-align: center;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      white-space: nowrap;
      line-height: 1.5;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      height: 32px;
      line-height: 29px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear;
      color: #515a6e;
      background-color: #fff;
      border-color: #dcdee2;
    }
    > div {
      display: flex;
      justify-content: space-between;
      > div {
        margin-right: 10px;
      }
      > button {
        margin-right: 10px;
      }
    }
  }
  .notice_box {
    padding: 0px 20px 20px 50px;
    .notice_box_title {
      font-weight: 600;
      font-size: 15px;
    }
    .notice_box_cont {
      display: block;
      padding: 10px 5px;
    }
  }
}
</style>

